import React, { useState } from "react";
import { getUser } from "../../Utils/helper";
import { APP_VERSION } from "../../Constants/androidApp";
import {
  dismissAndroidUpdateBanner,
  shouldShowAndroidUpdateBanner,
} from "../../Utils/androidAppBanner";
import AndroidAppDownloadModal from "../AndroidAppDownloadModal/AndroidAppDownloadModal";
import "./AndroidAppUpdateBanner.css";

const AndroidAppUpdateBanner = () => {
  const [visible, setVisible] = useState(() => shouldShowAndroidUpdateBanner());
  const [modalOpen, setModalOpen] = useState(false);
  const userAuth = getUser();

  if (!userAuth || !visible) return null;

  const handleDismiss = () => {
    dismissAndroidUpdateBanner();
    setVisible(false);
  };

  return (
    <>
      <div className="android_update_banner" role="alert">
        <p className="android_update_banner_text">
          A new version of the DH HRM Android app ({APP_VERSION}) is available.
          Download it to update your app.
        </p>
        <div className="android_update_banner_actions">
          <button
            type="button"
            className="android_update_banner_btn android_update_banner_btn_download"
            onClick={() => setModalOpen(true)}
          >
            Download
          </button>
          <button
            type="button"
            className="android_update_banner_btn android_update_banner_btn_dismiss"
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      </div>
      <AndroidAppDownloadModal open={modalOpen} setOpen={setModalOpen} />
    </>
  );
};

export default AndroidAppUpdateBanner;
